import { SelectOption } from '@/components/elements/select'

export const booleanMap: SelectOption[] = [
	{ label: 'Si', value: true },
	{ label: 'No', value: false },
]
